import {
  claimWatchlistEditLease,
  listenToWatchlistEditLease,
  releaseWatchlistEditLease
} from "@/firebase/firestore";
import { useContentEditLease } from "@/composables/useContentEditLease";

export const useWatchlistEditLease = ({ watchlistId, adminId, adminName }) =>
  useContentEditLease({
    contentId: watchlistId,
    adminId,
    adminName,
    contentLabel: "Watchlist",
    claimEditLease: claimWatchlistEditLease,
    listenToEditLease: listenToWatchlistEditLease,
    releaseEditLease: releaseWatchlistEditLease
  });
